module.exports = __webpack_public_path__ + "static/img/tx6-b.32e042d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx6-b.png
// module id = YGTo
// module chunks = 1